import { PresetColorType, PresetStatusColorType } from 'antd/lib/_util/colors';
import { LiteralUnion, Status } from 'app/definitions/types';

export const PRESETS_INSPECTION_STATUS = new Map<
  Status,
  [string, LiteralUnion<PresetColorType | PresetStatusColorType, string>]
>([
  ['pending', ['Pending Assign', 'success']],
  ['pendingAssign', ['Pending Assign', 'success']],
  ['waiting', ['Waiting', 'warning']],
  ['waitingAccept', ['Waiting Accept', 'warning']],
  ['waitingQuote', ['Waiting Quote', 'warning']],
  ['waiting for approval', ['Waiting for Approval', 'warning']],
  ['rejected', ['Inspection Rejected', 'error']],
  ['inspectionRejected', ['Inspection Rejected', 'error']],
  ['scheduledReject', ['Schedule Rejected', 'error']],
  ['scheduled', ['Scheduled', 'processing']],
  ['inProgress', ['In Progress', 'processing']],
  ['in-progress', ['In Progress', 'processing']],
  ['complete', ['Completed', 'success']],
  ['completed', ['Completed', 'success']],
  ['cancelled', ['Canceled', 'error']],
  ['approved', ['Approved', 'processing']],
  ['pass', ['Validate - PASS', 'success']],
  ['cap', ['Validate - CAP', 'error']],
  ['fail', ['Validate - Fail', 'error']],
  ['waitingPayment', ['Waiting Payment', 'warning']],
  ['underReview', ['Under Review', 'warning']],
  ['bookingReserved', ['Booking Reserved', 'warning']],
  ['inspectionReleased', ['Inspection Released', 'success']],
  ['inspectionReleasedWaiver', ['Inspection Released (Waiver)', 'success']],
  ['default', ['', 'default']]
]);

export const PRESETS_INSPECTION_RESULT = new Map<
  Status,
  [string, LiteralUnion<PresetColorType | PresetStatusColorType, string>]
>([
  ['pass', ['Passed', 'success']],
  ['passed', ['Passed', 'success']],
  ['rejected', ['Reject', 'error']],
  ['failed', ['Failed', 'error']],
  ['fail', ['Failed', 'error']],
  ['pending', ['Pending', 'default']],
  ['report-as-is', ['Report As Is', 'default']],
  ['not-applicable', ['Not Applicable', 'default']]
]);
